var _rect, _rect2, _rect3, _path, _rect4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMediumBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 24,
    viewBox: "0 0 89 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 10,
    rx: 1,
    transform: "matrix(-1 0 0 1 11 7)",
    fill: "#FF9847"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 10,
    rx: 1,
    transform: "matrix(-1 0 0 1 17 7)",
    fill: "#FF9847"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 10,
    rx: 1,
    transform: "matrix(-1 0 0 1 23 7)",
    fill: "#909090"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.232 16L29.496 9.916L29.556 16H28.248V7.6H29.748L32.784 14.404L35.784 7.6H37.308V16H35.964L36.024 9.868L33.288 16H32.232ZM39.791 16V7.6H45.995V8.752H41.159V11.188H45.383V12.352H41.159V14.848H46.115V16H39.791ZM51.1412 16H47.8652V7.6H51.1892C52.4452 7.6 53.3772 7.932 53.9852 8.596C54.5932 9.252 54.8972 10.304 54.8972 11.752C54.8972 13.192 54.5852 14.26 53.9612 14.956C53.3452 15.652 52.4052 16 51.1412 16ZM49.2692 14.836H51.0572C51.4252 14.836 51.7612 14.788 52.0652 14.692C52.3692 14.588 52.6252 14.416 52.8332 14.176C53.0412 13.936 53.2012 13.624 53.3132 13.24C53.4332 12.848 53.4932 12.364 53.4932 11.788C53.4932 11.236 53.4412 10.768 53.3372 10.384C53.2332 10 53.0812 9.688 52.8812 9.448C52.6892 9.208 52.4492 9.036 52.1612 8.932C51.8732 8.82 51.5452 8.764 51.1772 8.764H49.2692V14.836ZM56.9589 16V7.6H58.3629V16H56.9589ZM66.2736 12.724V7.6H67.6776V12.652C67.6776 13.836 67.3656 14.716 66.7416 15.292C66.1176 15.868 65.2576 16.156 64.1616 16.156C63.0336 16.156 62.1616 15.868 61.5456 15.292C60.9376 14.716 60.6336 13.836 60.6336 12.652V7.6H62.0376V12.724C62.0376 13.124 62.0856 13.468 62.1816 13.756C62.2856 14.044 62.4296 14.28 62.6136 14.464C62.7976 14.648 63.0176 14.784 63.2736 14.872C63.5376 14.96 63.8336 15.004 64.1616 15.004C64.8096 15.004 65.3216 14.828 65.6976 14.476C66.0816 14.116 66.2736 13.532 66.2736 12.724ZM73.939 16L71.203 9.916L71.263 16H69.955V7.6H71.455L74.491 14.404L77.491 7.6H79.015V16H77.671L77.731 9.868L74.995 16H73.939Z",
    fill: "#D0D0D0"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 88,
    height: 23,
    rx: 3.5,
    stroke: "#909090"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediumBadge);
export default __webpack_public_path__ + "static/media/mediumBadge.2bd88f42663e5fb7043be2df88dd8047.svg";
export { ForwardRef as ReactComponent };